import { render, staticRenderFns } from "./tiki.vue?vue&type=template&id=4fd38964&scoped=true"
import script from "./tiki.vue?vue&type=script&lang=js"
export * from "./tiki.vue?vue&type=script&lang=js"
import style0 from "./tiki.vue?vue&type=style&index=0&id=4fd38964&prod&scoped=true&lang=css"
import style1 from "./tiki.vue?vue&type=style&index=1&id=4fd38964&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd38964",
  null
  
)

export default component.exports